import React from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'
import CustomDatePicker from '../elements/CustomDatePicker'

const DateRangeSelect = (props) => {
    const pastDatesOnly = (date) => {
        const today = new Date()
        return today > date
    }

    return (
        <form onSubmit={props.handleSubmit} className='date-range-select'>
            <label className='mr-lg-3'>Show invoices from</label>
            <CustomDatePicker
                name='fromDate'
                value={props.fromDate}
                errors={null}
                handleChange={props.setDynamicValues}
                filterDate={pastDatesOnly}
            />
            <label className='mx-2'>to</label>
            <CustomDatePicker
                name='toDate'
                value={props.toDate}
                errors={null}
                handleChange={props.setDynamicValues}
                filterDate={pastDatesOnly}
                minDate={props.fromDate}
            />
            <div className='ml-lg-3'>
                <Button title='Search' action={props.handleSubmit} />
            </div>

            {props.children}
        </form>
    )
}

DateRangeSelect.propTypes = {
    fromDate: PropTypes.object.isRequired,
    toDate: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    setDynamicValues: PropTypes.func.isRequired
}

export default DateRangeSelect



// WEBPACK FOOTER //
// ./resources/js/components/DateRangeSelect.js